import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78116e5f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "has-first-letter-uppercase is-size-5" }
const _hoisted_2 = {
  key: 0,
  class: "avolta-list"
}
const _hoisted_3 = { class: "mb-3 section-title" }
const _hoisted_4 = {
  key: 0,
  class: "center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-card-off-outline is-size-4" }, null, -1 /* HOISTED */))
const _hoisted_6 = {
  key: 1,
  class: "avolta-list"
}
const _hoisted_7 = { class: "mb-3 section-title" }
const _hoisted_8 = {
  key: 0,
  class: "center"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-card-off-outline is-size-4" }, null, -1 /* HOISTED */))
const _hoisted_10 = {
  key: 2,
  class: "avolta-list"
}
const _hoisted_11 = { class: "mb-3 section-title" }
const _hoisted_12 = {
  key: 0,
  class: "center"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-card-off-outline is-size-4" }, null, -1 /* HOISTED */))
const _hoisted_14 = {
  key: 3,
  class: "avolta-list"
}
const _hoisted_15 = { class: "mb-3 section-title" }
const _hoisted_16 = {
  key: 0,
  class: "center"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-card-off-outline is-size-4" }, null, -1 /* HOISTED */))
const _hoisted_18 = {
  key: 4,
  class: "avolta-list"
}
const _hoisted_19 = { class: "mb-3 section-title" }
const _hoisted_20 = {
  key: 0,
  class: "center"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-card-off-outline is-size-4" }, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_device_list_item = _resolveComponent("device-list-item")!
  const _component_n_divider = _resolveComponent("n-divider")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    ref: "modal",
    width: "40vw",
    height: "60vh",
    class: "slot-details-modal"
  }, {
    header: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('time.from')) + " " + _toDisplayString(_ctx.start.format(_ctx.dateFormat)) + " " + _toDisplayString(_ctx.$t('time.to')) + " " + _toDisplayString(_ctx.end.format(_ctx.dateFormat)), 1 /* TEXT */)
    ]),
    body: _withCtx(() => [
      (_ctx.mode === 'alarm')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('slot_details.gas_alarm')), 1 /* TEXT */),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gasDevices, (device) => {
              return (_openBlock(), _createBlock(_component_device_list_item, {
                key: device.id,
                device: device,
                showStatus: false,
                since: _ctx.since,
                before: _ctx.before
              }, null, 8 /* PROPS */, ["device", "since", "before"]))
            }), 128 /* KEYED_FRAGMENT */)),
            (!_ctx.gasDevices?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('slot_details.no_station_found')), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_n_divider)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.mode === 'alarm')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('slot_details.trouble_alarm')), 1 /* TEXT */),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.troubleDevices, (device) => {
              return (_openBlock(), _createBlock(_component_device_list_item, {
                key: device.id,
                device: device,
                showStatus: false,
                since: _ctx.since,
                before: _ctx.before
              }, null, 8 /* PROPS */, ["device", "since", "before"]))
            }), 128 /* KEYED_FRAGMENT */)),
            (!_ctx.troubleDevices?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('slot_details.no_station_found')), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_n_divider)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.mode === 'alarm')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('slot_details.ok_device')), 1 /* TEXT */),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.okDevices, (device) => {
              return (_openBlock(), _createBlock(_component_device_list_item, {
                key: device.id,
                device: device,
                showStatus: false,
                since: _ctx.since,
                before: _ctx.before
              }, null, 8 /* PROPS */, ["device", "since", "before"]))
            }), 128 /* KEYED_FRAGMENT */)),
            (!_ctx.okDevices?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('slot_details.no_station_found')), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.mode === 'connection')
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('slot_details.offline')), 1 /* TEXT */),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offlineDevices, (device) => {
              return (_openBlock(), _createBlock(_component_device_list_item, {
                key: device.id,
                device: device,
                showStatus: false,
                since: _ctx.since,
                before: _ctx.before
              }, null, 8 /* PROPS */, ["device", "since", "before"]))
            }), 128 /* KEYED_FRAGMENT */)),
            (!_ctx.offlineDevices?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('slot_details.no_station_found')), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_n_divider)
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.mode === 'connection')
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('slot_details.online_devices')), 1 /* TEXT */),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.onlineDevices, (device) => {
              return (_openBlock(), _createBlock(_component_device_list_item, {
                key: device.id,
                device: device,
                showStatus: false,
                since: _ctx.since,
                before: _ctx.before
              }, null, 8 /* PROPS */, ["device", "since", "before"]))
            }), 128 /* KEYED_FRAGMENT */)),
            (!_ctx.onlineDevices?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('slot_details.no_station_found')), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}